export default __webpack_public_path__ + "images/0x1da40c742f32bbee81694051c0ee07485fc630f6.png";